import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { init as mainTheme } from '../../../pdc-widget-accordion/src/ts/themes/main';
import { AccordionWidget as mainModule } from './main';
import * as Config from './config';

declare var require: any;
require('../sass-main/pdc-widget-accordion.sass');

export class AccordionWidget extends WidgetBase {
    public static _name: string = Config.name;
    public static group = Config.group;
    public static moduleName: string = Config.moduleName;
    public static icon: string = Config.icon;
    public static namespace: string = Config.namespace;
    public static themeModule = mainTheme;
    public static containersNum: number = 1;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-accordion'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = 'widget-accordion';
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(AccordionWidget);
